import React from 'react';
import { colorForCategory, textOn, categorySlug } from '@/lib/categories';

export function CategoryBadge({ name, size = 'md' }) {
    const color = colorForCategory(name);
    const text = textOn(color);
    const sizeCls = size === 'sm'
        ? 'text-[10px] px-2.5 py-[3px]'
        : 'text-[11px] md:text-xs px-3 py-1';
    return (
        <span
            data-testid={`badge-${categorySlug(name)}`}
            className={`inline-flex items-center rounded-full font-bold uppercase tracking-[0.08em] whitespace-nowrap ${sizeCls}`}
            style={{ backgroundColor: color, color: text }}
        >
            {name}
        </span>
    );
}
